module.exports = __webpack_public_path__ + "static/media/s_v10_8.07138c36.mp3";